import React from 'react';
import Layout from '../components/Layout';
import ExchangeAccountManager from '../components/ExchangeAccountManager';

const TraoDoiSub: React.FC = () => (
  <Layout>
    <ExchangeAccountManager
      platform="traodoisub"
      title="TraoDoiSub"
      description="Quản lý account TraoDoiSub, import tài khoản, đăng nhập lấy cookie/token và cập nhật xu."
    />
  </Layout>
);

export default TraoDoiSub;